import React, { useRef, useContext, useEffect } from 'react';
import ProgressBar from '../../common/progressBar/ProgressBar';
import { TyreRepairRequestContext } from '../../../context/TyreRepairRequestContext';
import TyreSelection from './TyreSelection';
import { useTranslation } from 'react-i18next';
import { TyreProcessStages } from './TyreRepairRequestTypes';
import TyreGeneralDetails from './TyreGeneralDetails';
import { useLocation } from 'react-router-dom';
import TyreRepairRequestSummary from '../tyreRepairRequest/TyreRepairRequestSummary';
import LoadingContainer from '../../common/loadingContainer/LoadingContainer';

const TyreRepairRequest = (): JSX.Element => {
    const errorContainerRef = useRef<null | HTMLDivElement>(null);
    const scrollDivRef = useRef<null | HTMLDivElement>(null);
    const { t } = useTranslation();

    const { tyreRepairRequest, progressBarItems, onDealerAddressUpdate } =
        useContext(TyreRepairRequestContext);

    const { tyreStage, isLoadingOnSubmission, scrollToAddress, dealerAddress } =
        tyreRepairRequest;

    const location = useLocation();
    const { selectedDealerAddress } = location.state ?? {};

    useEffect(() => {
        if (!scrollToAddress) scrollDivRef.current?.scrollIntoView();
        if (dealerAddress === undefined && selectedDealerAddress) {
            onDealerAddressUpdate(selectedDealerAddress);
        }
    }, [tyreStage]);

    const cancelConfirmText = t('cancel_tyre_confirm_text');

    return (
        <>
            <div ref={scrollDivRef}></div>
            <ProgressBar
                id='tyreProgressBar'
                progressBarItems={progressBarItems}
            />
            {tyreStage === TyreProcessStages.General && (
                <TyreGeneralDetails cancelConfirmText={cancelConfirmText} />
            )}
            {tyreStage === TyreProcessStages.TyreSelection && (
                <TyreSelection cancelConfirmText={cancelConfirmText} />
            )}
            {tyreStage === TyreProcessStages.Summary && (
                <LoadingContainer
                    loading={isLoadingOnSubmission}
                    message={t('registering_requests')}>
                    <TyreRepairRequestSummary
                        cancelConfirmText={cancelConfirmText}
                    />
                </LoadingContainer>
            )}
            <div ref={errorContainerRef}></div>
        </>
    );
};

export default TyreRepairRequest;
